export function StrategyInfo({ strategy }: { strategy: string }) {
  return (
    <div className="strategy-info">
      <h3>Strategy</h3>
      <p>{strategy}</p>
    </div>
  )
}
